module.exports = __webpack_public_path__ + "6ca0af000669454de624cd98cb05e135.png";